import { createApp } from 'vue';
import Antd from 'ant-design-vue';

import 'ant-design-vue/dist/reset.css';
import './assets/styles/variables.css';
import './assets/styles/dark-tech-theme.css';
import App from './App.vue';

const isFetchFailure = (reason: unknown): boolean => {
  if (reason instanceof TypeError && reason.message === 'Failed to fetch') {
    return true;
  }

  if (reason instanceof Error) {
    return reason.message === 'Failed to fetch';
  }

  return false;
};

window.addEventListener('unhandledrejection', (event) => {
  if (isFetchFailure(event.reason)) {
    console.warn('Ignored transient fetch failure:', event.reason);
    event.preventDefault();
  }
});

const app = createApp(App);
app.use(Antd);
app.mount('#app');
